module.exports = __webpack_public_path__ + "static/media/icon_expand.1441b720.svg";